module.exports = __webpack_public_path__ + "static/media/sih.53cbcbf5.jpg";